import {useCookie, useNuxtApp} from "nuxt/app";
import {computed} from "vue";
import {useProfile} from "../store/profile";

export function useCustomerLogin() {
	const tokenCookie = useCookie("auth0.token");
	const {$customerLogin} = useNuxtApp();

	// The `customer-login` plugin loads the profile into the store, so the store
	// is our main source of truth here.
	const profileStore = useProfile();
	const profile = computed(() => profileStore.profile);

	return {
		profile,
		hasProfile: computed(() => !!profile?.value),
		// Use this to avoid showing UI in its logged-out state before the profile has
		// been loaded, see the `customer-login` plugin
		profileLoaded: computed(() => profileStore.isLoaded),
		flushProfile: () => profileStore.flushProfile(),
		token: tokenCookie,
		fetchProfile: $customerLogin.refetchProfile,
		refetch: $customerLogin.refetchProfile,
	};
}
